<template>
  <div id="nav">
    <router-link to="/"></router-link>
  </div>
  <Header></Header>
  <!-- <div style="margin-top:150px"></div>
   -->
  <img src="../assets/images/arrow.png"
       class="go-top"
       @click="
      scrollToTop;
      backTop(scrollTop);
    "
       style="border-radius: 50%" />
  <router-view />
  <Footer></Footer>
</template>

<script>
import { defineComponent, onBeforeMount, onBeforeUnmount, ref } from "vue";
import Header from "../components/Header.vue";
import Footer from "../components/footer.vue";
window.addEventListener('beforeunload', e => {
  window.scrollTo(0, 0)
})

let scrollToTop = () => {
  let scrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
  let res = ref(scrollTop);
  return res;
};

let backTop = (scrollTop) => {
  let timer = setInterval(() => {
    let ispeed = Math.floor(scrollTop / 5);
    document.documentElement.scrollTop = document.body.scrollTop =
      scrollTop + ispeed;
    if (scrollTop == 0) {
      clearInterval(timer);
    }
  }, 16);
};

export default defineComponent({
  components: {
    Header,
    Footer,
  },

  mounted () {
    // console.log(123)
    // setTimeout(() => {
    // window.scrollTo(0, 0)

    // }, 500);
    // window.scrollTo(0, 0)

  },

  watch: {
    '$route': function (to, from) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },

  setup () {
    let scrollTop = ref(0);
    let btnFlag = ref(false);
    let v = scrollToTop();
    scrollTop = v;
    if (scrollTop.value > 60) {
      btnFlag.value = true;
    }

    onBeforeMount(() => {
      window.addEventListener("scroll", scrollToTop);

    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", scrollToTop);
    });

    return { scrollTop, btnFlag, scrollToTop, backTop };
  },
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 0;
}

.go-top {
  position: fixed;
  z-index: 10;
  width: 50px;
  bottom: 60px;
  right: 20px;
  cursor: pointer;
  background-color: red;
}

body {
  margin: 0;
}
</style>
